import { Component, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import {MatDatepickerInputEvent, } from '@angular/material/datepicker';

export const DD_MM_YYYY_Format = {
  parse: {
      dateInput: 'LL',
  },
  display: {
      dateInput: 'DD/MM/YYYY',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY',
  },
};



@Component({
  selector: 'multipleDate',
  template: `<div [formGroup]="form">
      <mat-form-field appearance="outline">
        <mat-label>Choose {{field.label}}s {{field.required ? '*':''}}</mat-label>
        <input matInput [matDatepicker]="picker"  [value]="date.value"
        (dateInput)="addEvent('input', $event)"
        (dateChange)="addEvent('change', $event)">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker ></mat-datepicker>
        <mat-hint *ngIf="field && field.hint">{{field.hint}}</mat-hint>
        </mat-form-field>
</div>
    `, styles: [`.mat-calendar-table-header th{
      padding: 0px !important;
    }`],
    providers: [
      {provide: MAT_DATE_FORMATS, useValue: DD_MM_YYYY_Format},
  ]
})
export class MultipleDateComponent {
  get isValid() { return this.form.controls[this.field.name].valid; }
  get isDirty() { return this.form.controls[this.field.name].dirty; }
  constructor() { }
  @Input() field: any = {};
  @Input() form: FormGroup;
  public date;
  public selectedDate: string;
  events: string[] = [];
  ngOnInit() {
    console.log(this.field)
    const sp = this.field.value.split('/');
    const MMDDYYYY = sp[1] + '-' + sp[0] + '-' + sp[2];
    console.log('date directives', MMDDYYYY);
    this.date = new FormControl(new Date(MMDDYYYY));
  }

  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
      const val: any = event.targetElement;
      const finalDate = val.value.split('/');
      const year = finalDate[2];
      const month = finalDate[1];
      const date = finalDate[0];
      console.log(finalDate, year + '/' + month + '/' + date);


      this.assignDate(year + '/' + month + '/' + date);
  }
  assignDate(dateStr: string) {
    const fields: any = this.form.controls[this.field.name];
    fields.status = dateStr ? 'VALID' : 'INVALID';
    fields.value = dateStr ? dateStr : '';
    this.form.value[this.field.name] = dateStr ? dateStr : '';
  }
}
